<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="new-neighbours">
<h1>New Neighbours</h1>
<p style="text-indent: 00em;">When Nick gets home, it’s not hard to tell</p>
<p style="text-indent: 00em;">As his cattle truck leaves a rich rural smell</p>
<p style="text-indent: 00em;">There’s Bob, retired, across the way</p>
<p style="text-indent: 00em;">His agapanthuses are his bug bare</p>
<p style="text-indent: 00em;">He wanders around them every day</p>
<p style="text-indent: 00em;">And tops any buds that dare to appear</p><br/>
<p style="text-indent: 00em;">Then we have Allen on the top side</p>
<p style="text-indent: 00em;">He has lots of land rover wrecks he tries to hide</p>
<p style="text-indent: 00em;">Tucked down the side of the fence</p>
<p style="text-indent: 00em;">Amongst other junk and weeds so dense</p><br/>
<p style="text-indent: 00em;">John and Sue live at the back, Sue’s mum passed away this Christmas gone by</p>
<p style="text-indent: 00em;">She’d just had a triple bypass; they didn’t expect her to die</p>
<p style="text-indent: 00em;">Sue collects bears; she has hundreds it would seem</p>
<p style="text-indent: 00em;">I have one here, maybe he could join her team?</p>
<p style="text-indent: 00em;">Gary and son, Matt, live down the right of way</p>
<p style="text-indent: 00em;">Oh, and Nick, the cattle truck driver, is Gary’s son, I forgot to say</p>
<p style="text-indent: 00em;">Matt is a quadriplegic; he has helpers coming in all day</p>
<p style="text-indent: 00em;">It must be hard for him, but it’s the only way</p>
<p style="text-indent: 00em;">He has no movement from his neck down</p>
<p style="text-indent: 00em;">But he always has a smile, never a frown</p><br/>
<p style="text-indent: 00em;">Myreen is up the other road, she’s not long moved in</p>
<p style="text-indent: 00em;">She took some of the yellow daisies I was putting in the bin</p>
<p style="text-indent: 00em;">I nearly forgot there’s Jill and Bruce, Chris and another Sue</p>
<p style="text-indent: 00em;">They all live up our way too</p><br/>
<p style="text-indent: 00em;">And today I’ve met Melody, she lives three doors down</p>
<p style="text-indent: 00em;">She has settled here from out of town</p>
<p style="text-indent: 00em;">With her spotty dog she often goes walking</p>
<p style="text-indent: 00em;">I stopped to have a pat, that’s how we got talking.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?cb311b28